import type { PropsWithChildren } from "react";

export const EmptyStateView = ({ children }: PropsWithChildren) => (
  <div className="rounded-xl border border-dashed border-border/60 p-8 text-center text-sm text-muted-foreground">
    {children}
  </div>
);
